module.exports = __webpack_public_path__ + "../resources/img/ic_error_code_red.c93e0f57.svg";